import { render } from "./BaseWaiter.vue?vue&type=template&id=03a6fd78&scoped=true"
import script from "./BaseWaiter.vue?vue&type=script&lang=js"
export * from "./BaseWaiter.vue?vue&type=script&lang=js"

import "./BaseWaiter.vue?vue&type=style&index=0&id=03a6fd78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a6fd78"],['__file',"src/components/elements/waiter/BaseWaiter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03a6fd78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03a6fd78', __exports__)) {
    api.reload('03a6fd78', __exports__)
  }
  
  module.hot.accept("./BaseWaiter.vue?vue&type=template&id=03a6fd78&scoped=true", () => {
    api.rerender('03a6fd78', render)
  })

}


export default __exports__